import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {
  WorkflowPositionMissingGoldPriceAlertModal,
} from '../../../react/workflow/position/workflow-position-missing-goldprice-alert-modal';

const containerElementName = 'reactWorkflowPositionMissingGoldPrice';

@Component({
  selector: 'workflow-position-missing-gold-price',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WorkflowPositionMissingGoldPriceComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() labelHeader: string;
  @Input() labelCheckbox: string;
  @Input() labelButton: string;
  @Input() modalOpen: boolean;
  @Output() response: EventEmitter<'force' | 'abort'> = new EventEmitter<'force' | 'abort'>();

  constructor(private ngZone: NgZone) {
    super();
  }

  responseEmit(response: 'force' | 'abort'): void {
    this.ngZone.run(() => {
      this.response.emit(response);
    });
  }

  protected override renderComponent() {
    return <WorkflowPositionMissingGoldPriceAlertModal modal={this.modalOpen ? 'open' : 'closed'}
                                                       labelHeader={this.labelHeader}
                                                       labelCheckbox={this.labelCheckbox}
                                                       labelButton={this.labelButton}
                                                       response={(r) => this.responseEmit(r)}/>;
  }
}
